import React, { PureComponent } from "react";
import LazyLoad from "react-lazyload";

class SearchList extends PureComponent {
  render() {
    const { groups, iconPath } = this.props;
    return Object.keys(groups).map(sectionName => (
      <div className="quest-cards search-page__cards" key={sectionName}>
        <div className="quest-cards__top">
          <a
            href={`/${groups[sectionName].slug}`}
            className="link link_dashed quest-cards__link"
          >
            <span className="link__text">{sectionName}</span>
          </a>
        </div>
        <ul className="grid quest-grid">
          {groups[sectionName].coll.map(amus => (
            <li
              className="grid__col grid__col_xl_4 grid__col_lg_6 grid__col_md_6 grid__col_sm_12 quest-grid__item"
              key={amus.id}
            >
              <a href={amus.url} className="card">
                <div className="card__header">
                  <LazyLoad once offset={500}>
                    <picture className="card__bg">
                      {amus.thumbnail && amus.thumbnail.webp && (
                        <source
                          type="image/webp"
                          srcset={amus.thumbnail.webp.url}
                        />
                      )}
                      <img src={amus.thumbnail.url} />
                    </picture>
                  </LazyLoad>
                  {amus.sticker && amus.sticker !== "" && (
                    <div className="card__header-top">
                      <div className="card__price">{amus.sticker}</div>
                    </div>
                  )}
                  <div className="card__header-bottom">
                    {amus.qq_plus && (
                      <div className="qq-plus">
                        <svg
                          className="qq-plus__check"
                          fill="none"
                          viewBox="0 0 10.4 8.11"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M0.7 3.91 3.57 6.71 9.7 0.71" />
                        </svg>
                        <span className="qq-plus__text">QQ Plus</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="card__content">
                  <div className="card__body">
                    <p className="card__title">{amus.name}</p>
                    <div className="card__rating">
                      <ul className="rating">
                        {[1, 2, 3, 4, 5].map(num => {
                          const svgClass =
                            amus.score < num
                              ? ""
                              : amus.score >= num
                              ? "-full-"
                              : "-semi-";
                          return (
                            <li className="rating__item" key={num}>
                              <svg
                                className={`rating__star star ${svgClass}`}
                                viewBox="0 0 12 11.92"
                              >
                                <path
                                  className="star__empty"
                                  d="M7.41 3.99l.12.3.31.03 3.66.32-2.79 2.54-.23.2.07.3.83 3.74-3.1-1.96-.28-.18-.28.18-3.1 1.96.83-3.74.07-.3-.23-.2-2.79-2.54 3.66-.32.31-.03.12-.3 1.41-3.49 1.41 3.49z"
                                />
                                <path
                                  className="star__semi"
                                  d="M6 0.5 6 9.28 2.62 11.42 3.52 7.38 0.5 4.64 4.47 4.29 6 0.5z"
                                />
                                <path
                                  className="star__full"
                                  d="M6 0.5 6 9.28 9.38 11.42 8.48 7.38 11.5 4.64 7.53 4.29 6 0.5z"
                                />
                              </svg>
                            </li>
                          );
                        })}
                      </ul>
                      <p className="card__rating-text">{amus.review_count}</p>
                    </div>
                    <ul className="chars card__chars">
                      <li className="chars__item icon-block">
                        <svg className="chars__icon">
                          <use xlinkHref={`${iconPath}#icon_user`} />
                        </svg>
                        <p className="chars__text">{amus.players}</p>
                      </li>
                      <li className="chars__item icon-block">
                        <svg className="chars__icon">
                          <use xlinkHref={`${iconPath}#icon_time`} />
                        </svg>
                        <p className="chars__text">{amus.duration}</p>
                      </li>
                    </ul>
                  </div>
                  <div className="card__bottom">
                    <div className="icon-block">
                      <svg className="card__icon">
                        <use xlinkHref={`${iconPath}#icon_train`} />
                      </svg>
                      <p className="card__address">{amus.address}</p>
                    </div>
                    <p className="card__age">{amus.minimal_age}+</p>
                  </div>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    ));
  }
}

export default SearchList;
